import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatButton } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import {
  MatButtonToggleChange,
  MatButtonToggleModule,
} from '@angular/material/button-toggle'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { Clipboard } from '@angular/cdk/clipboard'
import { PurchaseScheduleService } from '../../../core/services/purchase-reservation/purchase-schedule/purchase-schedule.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { PurchaseServiceOrderService } from '../../../core/services/purchase-reservation/purchase-service-order/purchase-service-order.service'
import { SearchPurchaseScheduleServiceOrderModel } from '../../../core/models/purchase-reservation.model'
import { FormSearchPurchaseReservationServiceOrderComponent } from '../../../shared/components/form-search-purchase-reservation-service-order/form-search-purchase-reservation-service-order.component'
import { TableListPurchaseReservationServiceOrderComponent } from '../../../shared/components/table-list-purchase-reservation-service-order/table-list-purchase-reservation-service-order.component'
import { PurchaseReservationEditModalComponent } from '../purchase-reservation-edit-modal/purchase-reservation-edit-modal.component'
import { PurchaseReservationEditBatchModalComponent } from '../purchase-reservation-edit-batch-modal/purchase-reservation-edit-batch-modal.component'
import { PurchaseReservationNotifyModalComponent } from '../purchase-reservation-notify-modal/purchase-reservation-notify-modal.component'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'purchase-reservation-service-order',
  imports: [
    MatProgressBar,
    MatButton,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    FormSearchPurchaseReservationServiceOrderComponent,
    TableListPurchaseReservationServiceOrderComponent,
  ],
  templateUrl: './purchase-reservation-service-order.component.html',
  styleUrl: './purchase-reservation-service-order.component.scss',
  standalone: true,
})
export class PurchaseReservationServiceOrderComponent implements OnInit {
  constructor(
    private agendaComprasService: PurchaseScheduleService,
    private serviceOrderService: ServiceOrderService,
    private comprasOrdemServicoService: PurchaseServiceOrderService,
    private dialog: MatDialog,
    private snackbarCustomService: SnackbarCustomService,
    private clipboard: Clipboard,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }
  pendenteFilter: boolean | null = null
  selectionMode = false
  selectedCosIds: string[] = []
  private readonly selectColumn = {
    keyColumn: 'select',
    key: 'select',
    description: '',
  }

  columns: any[] = [
    {
      keyColumn: 'os_info',
      key: 'os_info',
      description: 'OS / TG',
    },
    {
      keyColumn: 'period',
      key: 'period',
      description: 'Período',
    },
    {
      keyColumn: 'trecho',
      key: 'trecho',
      description: 'Trecho',
    },
    {
      keyColumn: 'pax',
      key: 'pax',
      description: 'Pax',
    },
    {
      keyColumn: 'servico_info',
      key: 'servico_info',
      description: 'Serviço',
    },
    {
      keyColumn: 'status_info',
      key: 'status_info',
      description: 'Status',
    },
    {
      keyColumn: 'fornecedor',
      key: 'fornecedor',
      description: 'Fornecedor',
    },
    {
      keyColumn: 'action',
      key: { edit: true, copyLink: true, sendEmail: true, sendToFleet: true },
      description: 'Ações',
    },
  ]

  ngOnInit() {
    this.getListItems()
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({ ...item })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.agendaComprasService.listPagedOs(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: any) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    const model: SearchPurchaseScheduleServiceOrderModel = {
      ...new SearchPurchaseScheduleServiceOrderModel(),
      ...this.searchForm.model,
      pendente: this.pendenteFilter,
    }
    this.agendaComprasService
      .searchPagedOs(this.page, this.rows, model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: any) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  changePendenteFilter(event: MatButtonToggleChange) {
    this.pendenteFilter = event.value
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search || this.pendenteFilter !== null) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(PurchaseReservationEditModalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1100px',
      maxWidth: '95vw',
      data: { item },
    })
    dialogRef.componentInstance.response.subscribe((response: any) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  copyLinkItem(item: any) {
    this.comprasOrdemServicoService.getLinkAcessoWhatsApp(item.cosId).subscribe({
      next: (response: any) => {
        const link = response.data?.linkWhatsApp
        if (link && this.clipboard.copy(link)) {
          this.snackbarCustomService.success(
            'Link copiado para a área de transferência.',
          )
        } else {
          this.snackbarCustomService.warning('Link indisponível para esta OS.')
        }
      },
      error: (err: any) => {
        this.snackbarCustomService.errorRequest(err)
      },
    })
  }

  sendEmailItem(item: any) {
    this.comprasOrdemServicoService
      .notificar({
        comprasOsIds: [item.cosId],
        enviarEmail: true,
        gerarLinkWhatsApp: false,
      })
      .subscribe({
        next: (response: any) => {
          const emailsEnviados = response.data?.emailsEnviados ?? 0
          if (emailsEnviados > 0) {
            this.snackbarCustomService.success(
              'E-mail enviado ao fornecedor com sucesso.',
            )
          } else {
            this.snackbarCustomService.warning(
              'Nenhum e-mail enviado (OS sem fornecedor atribuído).',
            )
          }
        },
        error: (err: any) => {
          this.snackbarCustomService.errorRequest(err)
        },
      })
  }

  startSelection() {
    this.selectionMode = true
    this.selectedCosIds = []
    if (!this.columns.some((c) => c.keyColumn === 'select')) {
      this.columns = [this.selectColumn, ...this.columns]
    }
  }

  cancelSelection() {
    this.selectionMode = false
    this.selectedCosIds = []
    this.columns = this.columns.filter((c) => c.keyColumn !== 'select')
  }

  toggleSelectItem(item: any) {
    const index = this.selectedCosIds.indexOf(item.cosId)
    if (index === -1) {
      this.selectedCosIds.push(item.cosId)
    } else {
      this.selectedCosIds.splice(index, 1)
    }
  }

  toggleSelectAllItems(checked: boolean) {
    this.selectedCosIds = checked
      ? this.itemsList.map((item: any) => item.cosId)
      : []
  }

  confirmSelection() {
    if (this.selectedCosIds.length === 0) {
      this.snackbarCustomService.warning('Selecione ao menos uma OS.')
      return
    }
    const dialogRef = this.dialog.open(PurchaseReservationEditBatchModalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '900px',
      maxWidth: '95vw',
      data: {
        comprasOsIds: [...this.selectedCosIds],
        itens: this.itemsList.filter((item: any) =>
          this.selectedCosIds.includes(item.cosId),
        ),
      },
    })
    dialogRef.componentInstance.response.subscribe((response: any) => {
      if (response) {
        this.cancelSelection()
        this.uploadList()
      }
    })
  }

  notifySelection() {
    if (this.selectedCosIds.length === 0) {
      this.snackbarCustomService.warning('Selecione ao menos uma OS.')
      return
    }
    const dialogRef = this.dialog.open(PurchaseReservationNotifyModalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '600px',
      maxWidth: '95vw',
      data: { comprasOsIds: [...this.selectedCosIds] },
    })
    let notified = false
    dialogRef.componentInstance.response.subscribe((response: any) => {
      notified = notified || !!response
    })
    dialogRef.afterClosed().subscribe(() => {
      if (notified) {
        this.cancelSelection()
        this.uploadList()
      }
    })
  }

  sendToFleetItem(item: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Enviar para Frota',
        message: `Deseja enviar a OS ${item.codigoOs} para Frota?`,
        confirmLabel: 'Enviar',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.serviceOrderService
        .transferirResponsavel(item.codigoOs, 'FROTA')
        .subscribe({
          next: () => {
            this.snackbarCustomService.success('OS enviada para Frota com sucesso.')
            this.uploadList()
          },
          error: (err: any) => {
            this.snackbarCustomService.errorRequest(err)
          },
        })
    })
  }
}
